import { object, string, null as zNull } from "zod/v4";

export const createWayfairIntegration = {
  name: "createWayfairIntegration" as const,
  input: object({
    clientId: string().min(1, "Client ID is required"),
    clientSecret: string().min(1, "Client Secret is required"),
  }),
  output: zNull(),
};
